import { render } from "./IconText.vue?vue&type=template&id=562665d8&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"

import "./IconText.vue?vue&type=style&index=0&id=562665d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-562665d8"

export default script